module.exports = __webpack_public_path__ + "img/lock.dc88d8d4.svg";